module.exports = __webpack_public_path__ + "static/img/guest23.83d1e0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest23.png
// module id = ldZI
// module chunks = 0